
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCommandIn as ObiCommandInElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-command-in.js';
 
 
 

 
 export const ObiCommandIn = createComponent({
   react: React,
   tagName: 'obi-command-in',
   elementClass: ObiCommandInElement,
   events: {
     
   }
  });
 
 